var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGroup2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 576,
    height: 214,
    viewBox: "0 0 576 214",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M270.183 209.244c117.588 0 305.071 26.4 305.071-53.088 0-79.489-103.912-63.386-164.939-82.748C349.288 54.045 324.71 0 207.12 0 89.532 0-15.219 28.667 2.774 121.64c17.993 92.973 149.82 87.604 267.409 87.604z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F5F6FA",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.25,
    cy: 124.5,
    r: 18.5,
    fill: "#9FA0AD",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9E3",
    d: "M95.79 94.976c26.797 0 78.691 44.807 155.684 134.42L-10 181.689C33.73 123.88 68.993 94.976 95.79 94.976z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAF0",
    d: "M209.312 122.971c39.179 7.108 69.64 30.847 170.88 74.053 23.735 10.13 67.945 24.914 132.63 44.355l-395.92-23.886c-46.244-8.897-68.604-15.72-67.079-20.47 15.585-48.524 120.31-81.16 159.489-74.052z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8991DC",
    d: "M409.452 145.814c.836-.994 1.393-2.203 1.273-3.545-.346-3.867-5.847-2.92-6.886-.946-1.039 1.973-.825 6.927.568 7.252.556.13 1.728-.232 2.914-.959l-.661 5.216 4.443-.078-1.651-6.94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191847",
    d: "M407.91 145.568c.568 1.024 1.344 1.79 2.105 1.776 1.447-.025 2.442-1.933 2.406-3.964a5.245 5.245 0 0 0-.008-.212c1.548.999 2.762 3 4.787 2.965 2.754-.048 3.753-5.495-.095-5.428-2.617.046-3.897.44-4.997 1.012-.23-.6-.572-1.1-.986-1.447a1.493 1.493 0 0 0-.448-.3 2.077 2.077 0 0 0-.37-.147c-.673-.228-1.645-.38-2.728-.399-.203-.003-.401-.002-.595.004-.02-.996-.862-1.789-1.883-1.771-1.022.018-1.837.842-1.82 1.841.017.967.806 1.743 1.783 1.777.561.158 1.28.27 2.077.307a3.692 3.692 0 0 0-.102.973c.005.322.048.662.12 1.008.17-.204.398-.339.632-.343a1.098 1.098 0 0 1 1.13 1.066c.013.71-.398 1.23-1.009 1.282z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8991DC",
    d: "M411.68 168.94l-8.755 23.45-5.8 19.796-2.426.042 8.642-43.142z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8991DC",
    d: "M413.524 168.908c.24 8.183 1.855 19.176 2.091 19.682.158.338 5.464 4.571 15.919 12.701l-1.64 1.825c-12.289-6.912-18.723-10.838-19.303-11.779-.869-1.41-3.847-14.479-6.19-22.27l9.123-.159z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4E4E4",
    d: "M432.14 201.063c.693.26 1.17.497 1.431.71.3.241.701.637 1.205 1.187l-6.507 8.036c-.973-.441-1.309-.913-1.008-1.415.3-.502.545-.922.734-1.262l1.095-5.344a.133.133 0 0 1 .175-.099l.931.33c.564-.234.95-.48 1.162-.741.18-.222.322-.622.426-1.2a.267.267 0 0 1 .357-.202zM398.079 211.788c.245.697.37 1.215.376 1.552.007.384-.038.947-.135 1.687l-10.34.18c-.286-1.029-.14-1.59.437-1.682a49.672 49.672 0 0 0 1.439-.248l4.797-2.597a.133.133 0 0 1 .189.07l.346.926c.54.281.979.419 1.314.413.285-.005.683-.153 1.193-.444a.267.267 0 0 1 .384.143z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#89C5CC",
    d: "M406.235 209.998l-11.557-1.056 7.856-39.842 10.332-.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1DEE2",
    d: "M429.097 198.435l-7.409 9.128c-8.122-8.604-12.868-14.228-14.237-16.871-1.37-2.644-2.685-9.847-3.946-21.609l11.631-.203c.758 10.354 1.241 15.77 1.45 16.25.21.478 4.38 4.913 12.511 13.305z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#8991DC",
    d: "M395.228 164.056l-6.872-2.851c-1.215-1.16-2.384-2.037-3.508-2.631-.334-.1-.903-.121-.281.746.621.868 1.236 1.808 1 2.12-.238.313-.946-.015-1.214.49-.18.337 1.01.716 3.57 1.136l5.175 3.794 2.13-2.804zm27.585.337l-3.844.826c4.004 7.1 6.15 10.863 6.439 11.288.65.956.09 2.74-.112 3.678 1.375.292.8-1.742 2.54-1.346 1.588.362 2.946 1.338 4.397-.035.179-.17.302-.69-.32-.945-1.552-.635-3.849-1.834-4.226-2.309-.515-.647-2.14-4.367-4.874-11.157z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB2721",
    d: "M408.224 150.334l-1.632-.249c-3.486 3.472-4.79 11.69-7.132 12.815-2.216 1.064-5.4.128-9.186-1.146l-1.108 2.573c3.483 3.61 10.822 6.581 13.744 4.76 4.671-2.91 5.585-13.034 5.314-18.753z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDE3E9",
    d: "M415.672 170.491l-14.4.252c-.658.011-.55-.933-.463-1.41 1.002-5.507 5.184-11.496 5.048-19.307l4.142-.719c3.531 5.42 4.837 12.145 5.673 21.184z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4133",
    d: "M417.012 164.91c3.027 5.2 5.56 8.938 7.6 11.213l3.008-.639c-2.153-11.924-7.937-20.65-17.353-26.181l-.75.013-.895.015c-3.509 12.67-4.39 21.087-2.644 25.25l12.962-.226c-.258-3.064-.972-6.297-1.928-9.444z"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2);
export default __webpack_public_path__ + "static/media/group-2.19f862099b6a513ddb6996a4d2d937bb.svg";
export { ForwardRef as ReactComponent };